import { DeviceType } from '@app/store/typings/actions/device.d';
import { DeviceData, DeviceState } from '@app/store/typings/state/device.d';

const initState: DeviceState = {
  devices: {},
  modal: {
    locker: false,
  },
  assets: {
    lockers: [],
  },
};

export const device = (state = initState, action: DeviceType) => {
  switch (action.type) {
    case 'KEY_DEVICE_ZONE_FETCH':
      let dataAsset: DeviceData = state.devices[action.payload.zone];
      if (!dataAsset) {
        dataAsset = {
          loading: true,
          data: [],
          meta: { limit: 10, offset: 0, total: 0 },
        };
      }

      dataAsset.loading = true;
      state.devices[action.payload.zone] = dataAsset;

      return { ...state };
    case 'KEY_DEVICE_ZONE_SET_DATA':
      state.devices[action.payload.zone].loading = false;
      state.devices[action.payload.zone].data = action.payload.data;
      state.devices[action.payload.zone].meta = action.payload.meta;
      return { ...state };
    case 'KEY_DEVICE_ZONE_RESET_DATA':
      state.devices = {};
      return { ...state };
    case 'KEY_DEVICE_MODAL_ADD_LOCKER':
      state.modal.locker = !state.modal.locker;

      if (action.payload.modal !== undefined) {
        state.modal.locker = action.payload.modal;
      }
      return { ...state };
    case 'KEY_DEVICE_ADD_LOCKER':
      state.assets.lockers.push(action.payload);
      return { ...state };
    case 'KEY_DEVICE_EDIT_LOCKER':
      state.assets.lockers[action.payload.index] = action.payload.data;
      return { ...state };
    default:
      return state;
  }
};
